// src/pages/ResetPassword.js
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

// Material UI bileşenleri
import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
} from "@mui/material";

const ResetPassword = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basit doğrulamalar
    if (!newPassword || !confirmPassword) {
      setMessage("Lütfen tüm şifre alanlarını doldurun.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage("Girilen şifreler eşleşmiyor.");
      return;
    }

    try {
      // Şifre sıfırlama isteği -> bakapps.site
      const response = await axios.post(
        `https://bakapps.site/auth/reset-password/${token}`,
        { password: newPassword }
      );
      // Başarılı veya gelen mesaj
      setMessage(response.data.message || "Şifreniz başarıyla güncellendi.");
    } catch (error) {
      console.error("Reset password error:", error);
      const errorMessage =
        (error.response &&
          error.response.data &&
          error.response.data.error) ||
        "Şifre sıfırlama başarısız oldu. Token geçersiz olabilir.";
      setMessage(errorMessage);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 5 }}>
      <Card sx={{ boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Şifre Sıfırla
          </Typography>
          {message && (
            <Typography variant="body1" color="error" sx={{ mb: 2 }}>
              {message}
            </Typography>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              type="password"
              label="Yeni Şifre"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              type="password"
              label="Şifre Tekrar"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              fullWidth
              margin="normal"
            />

            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 2, textTransform: "none" }}
            >
              Şifreyi Güncelle
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ResetPassword;
